// extracted by mini-css-extract-plugin
module.exports = {"modal":"voice-selector-modal-base_modal__XQpNE","content":"voice-selector-modal-base_content__S6E6R"};